import {
  CONFIG_LOADING,
  CONFIG_LOADED,
  CONFIG_LOAD_ERROR,
  RESET_CONFIG,
  FEEDBACK_LOADED,
  FEEDBACK_LOADING,
  FEEDBACK_LOAD_ERROR,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case RESET_CONFIG:
      localStorage.removeItem("config");
      return {
        ...state,
        ...action.payload,
      };
    case CONFIG_LOADING:
      return { ...state, loading: true };
    case CONFIG_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CONFIG_LOADED:
      // console.log("GenConfig:", action.payload.generalConfig);
      // console.log("patronConfig:", action.payload.patronConfig);
      // console.log("validationRules:", action.payload.validationRules);
      return {
        ...state,
        generalConfig: action.payload.generalConfig,
        patronConfig: action.payload.patronConfig,
        validationRules: action.payload.validationRules,
        patronMessageConfig: action.payload.patronMessageConfig,
        sponserMessageConfig: action.payload.sponserMessageConfig,
        loading: false,
        loaded: action.payload.loaded,
        error: null,
      };
    // case PATRON_CONFIG_LOADED:
    //         return{
    //             ...state,
    //             patronConfig: action.payload.patronConfig,
    //             loading: false,
    //             loaded: action.payload.loaded,
    //             error: null
    //         };
    case FEEDBACK_LOADED:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case FEEDBACK_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FEEDBACK_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
